<div
  tabindex="0"
  role="button"
  (keydown.enter)="switchTheme($event)"
  (click)="switchTheme($event)"
  aria-label="Changer de thème"
>
  <fa-icon [icon]="['fas', theme() === 'dark' ? 'sun' : 'moon']"></fa-icon>
</div>
